import type { PaymentMethodsOut } from "../api";

/** Work Journal UI projection: legacy unknown data remains in the API payload. */
export function knownPaymentMethods(data: PaymentMethodsOut) {
  const buckets = data.buckets.filter((bucket) => bucket.usul !== null);
  const total = buckets.reduce(
    (sum, bucket) => sum + (parseFloat(bucket.summa) || 0),
    0,
  );
  return {
    buckets,
    total,
    percentages: buckets.map((bucket) =>
      total > 0
        ? Math.round(((parseFloat(bucket.summa) || 0) / total) * 100)
        : 0,
    ),
  };
}
